<template>
  <div>
    <base-dialog :show="successModal" small>
      <div class="success my-10">
        <img src="../assets/success.svg" alt="" />
        <h2 class="mt-10 text-white">{{ successText }}</h2>
      </div>
    </base-dialog>
    <div class="contentArea">
      <div class="card w-6/12">
        <div class="image-container">
          <img
            v-if="displayImage"
            class="image-item"
            :src="displayImage"
            alt="Girl in a jacket"
          />
          <div v-else class="no-image">
            <p class="center-text">{{ profile }}</p>
          </div>
          <input
            type="file"
            accept="image/*"
            name="image"
            id="file"
            style="display: none"
            ref="fileInput"
            @change="onSelectFile($event)"
          />
          <label for="file">
            <p class="change-img">เปลี่ยนรูป</p>
          </label>
        </div>
        <div class="grid grid-cols-12 gap-y-3 items-baseline mt-10">
          <p class="col-span-3">ประเภทแอดมิน :</p>
          <!-- <input class="col-span-9" v-model="roleName" type="text" /> -->
          <p class="col-span-9 text-white ml-2">{{ roleName }}</p>
          <p class="col-span-3">ชื่อ :</p>
          <input class="col-span-9" v-model="name" type="text" required />
          <p class="col-span-3">ชื่อผู้ใช้ :</p>
          <input class="col-span-9" v-model="username" type="text" required />
          <transition name="fade-in">
            <div
              v-if="displayChangePassword"
              class="col-span-12 grid grid-cols-12 gap-y-3 items-baseline"
            >
              <p class="col-span-3">รหัสผ่านเก่า :</p>
              <input
                class="col-span-9"
                type="password"
                v-model="oldPass"
                required
              />
              <p class="col-span-3">รหัสผ่านใหม่ :</p>
              <input
                class="col-span-9"
                type="password"
                v-model="newPass"
                required
              />
              <p class="col-span-3">ยืนยันรหัสผ่านใหม่ :</p>
              <input
                class="col-span-9"
                type="password"
                v-model="confirmPass"
                required
              />
              <p
                v-if="newPass !== confirmPass"
                class="col-start-4 col-span-9 error-text"
              >
                รหัสผ่านไม่ตรงกัน
              </p>
              <div class="col-start-4 col-span-9 grid grid-cols-2 gap-x-3">
                <vs-button
                  color="#ffffff"
                  style="box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.09);"
                  text-color="#8d9498"
                  @click="displayChangePassword = false"
                >
                  ยกเลิก
                </vs-button>
                <vs-button
                  color="#15c1c3"
                  :disabled="
                    newPass !== confirmPass || newPass === '' || oldPass === ''
                  "
                  @click="changePassword"
                >
                  ยืนยันการเปลี่ยนรหัส
                </vs-button>
              </div>
            </div>
          </transition>
          <div class="col-span-9 col-start-4">
            <u
              v-if="!displayChangePassword"
              @click="displayChangePassword = true"
              >เปลี่ยนรหัสผ่าน</u
            >
          </div>
        </div>
      </div>
      <div class="w-6/12">
        <div class="grid grid-cols-8 gap-4 mt-5">
          <vs-button
            class="col-span-2 col-end-9"
            color="#999da6"
            v-if="!displayChangePassword"
            @click="submitForm"
          >
            บันทึก
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "../util/backend.js";
import fileUrl from "../util/backendfile.js";
import Compressor from "compressorjs";
export default {
  data() {
    return {
      successModal: false,
      successText: "",
      roleName: "",
      picLetter: "",
      displayImage: null,
      profileImageLink: null,
      name: "",
      username: "",
      oldPass: "",
      newPass: "",
      confirmPass: "",
      displayChangePassword: false,
    };
  },
  computed: {
    profile() {
      return this.picLetter || "";
    },
  },
  methods: {
    async submitForm() {
      const res = await axios.post(
        `${baseUrl}/profile/edit?user_id=${this.$store.getters.getUserId}`,
        {
          name: this.name,
          username: this.username,
          img_profile: this.profileImageLink || this.displayImage,
        },
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      console.log(res.data.status);
      if (res.data.status === "success") {
        this.picLetter = this.name[0].toUpperCase();
        this.$store.dispatch("changeName", this.name);
        this.$store.dispatch(
          "changePic",
          this.profileImageLink || this.displayImage
        );
        this.successText = "บันทึกสำเร็จ";
        this.successModal = true;
        setTimeout(() => {
          this.successModal = false;
        }, 1000);
      }
    },
    async changePassword() {
      try {
        const res = await axios.post(
          `${baseUrl}/profile/edit?user_id=${this.$store.getters.getUserId}`,
          {
            password: this.oldPass,
            new_password: this.newPass,
          },
          {
            headers: {
              Authorization: this.$store.getters.getToken,
            },
          }
        );
        console.log(res);
        if (res.data.status === "success") {
          this.displayChangePassword = false;
          this.successText = "เปลี่ยนรหัสผ่านสำเร็จ";
          this.successModal = true;
          this.oldPass = "";
          this.newPass = "";
          this.confirmPass = "";
          setTimeout(() => {
            this.successModal = false;
          }, 1000);
        } else {
          alert(res.data.message);
        }
      } catch (err) {
        alert(err);
      }
    },
    async loadProfile() {
      const res = await axios.get(
        `${baseUrl}/profile?user_id=${this.$store.getters.getUserId}`,
        {
          headers: {
            Authorization: this.$store.getters.getToken,
          },
        }
      );
      const userData = res.data.data;
      this.picLetter = userData.name[0].toUpperCase();
      this.roleName = userData.role_name;
      this.name = userData.name;
      this.username = userData.username;
      this.displayImage = userData.img_profile;
      console.log(res.data);
    },
    async onSelectFile(e) {
      // this.imageLoading = true;
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.displayImage = event.target.result;
        };
        reader.readAsDataURL(file);
        let fileforupload = await this.compressImage(file);
        var fileupload = new File([fileforupload], file.name, {
          type: "image/jpeg",
        });
        let formData = new FormData();
        formData.append("file", fileupload);
        formData.append("folder_id", 1);
        await axios.post(`${fileUrl}/file/create`, formData).then((res) => {
          console.log("res", res);
          this.profileImageLink = res.data.data.uploadFileAtLevel.url;
          // this.imageLoading = false;
        });
      }
    },
    compressImage(file) {
      return new Promise((resolve, reject) => {
        new Compressor(file, {
          quality: 0.6,
          success(result) {
            resolve(result);
          },
          error(e) {
            reject(e);
          },
        });
      });
    },
  },
  created() {
    this.loadProfile();
  },
};
</script>

<style scoped>
.success {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card {
  background-color: #4e5363;
  border-radius: 5px;
  padding: 35px;
}

p {
  color: #dddddd
}

img {
  width: 30%;
}

u {
  color: #03a9f3;
  font-size: 11px;
  cursor: pointer;
}

input[type="text"],
input[type="password"] {
  height: 34px;
  border-radius: 2px;
  background: #3a3f51;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding-left: 10px;
}

.image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-container .change-img {
  font-size: 11px;
  color: #dddddd;
  opacity: 0.4;
  margin-top: 5px;
  cursor: pointer;
}

.image-item {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.no-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #e2e2e2;
}

.center-text {
  color: black;
  font-size: 30px;
  font-weight: 600;
}

.error-text {
  font-size: 12px;
  color: #ff4a3d;
  margin-top: -8px;
}

.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
  /* transform: translateX(50%); */
}

.fade-in-enter-active {
  transition: all 0.3s ease-out;
}

.fade-in-leave-active {
  transition: all 0.3s ease-in;
}

.fade-in-enter-to,
.fade-in-leave {
  opacity: 1;
  /* transform: translateX(0%); */
}
</style>
